import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { TablePersistenceService } from '../../../services/table/table-persistence.service';

@Component({
  selector: 'app-table-config',
  templateUrl: './table-config.component.html',
  styleUrls: ['./table-config.component.scss']
})
export class TableConfigComponent implements OnInit {
  @Input() tableKey!: string;
  @Input() allColumns: { id: string; name: string }[] = [];
  @Input() displayedColumns: string[] = [];
  @Output() displayedColumnsChange = new EventEmitter<string[]>();

  constructor(private tablePersistenceService: TablePersistenceService) {}

  ngOnInit() {
    const saved = this.tablePersistenceService.getColumns(this.tableKey);
    if (saved && saved.length > 0) {
      const validSaved = saved.filter(col => 
        this.allColumns.some(c => c.id === col) || col === 'check' || col === 'action' || col === 'actions' || col === 'id' || col === 'comment' || col === 'partition' || col === 'quantity'
      );
      if (validSaved.length > 0) {
        this.displayedColumns = validSaved;
        setTimeout(() => {
          this.displayedColumnsChange.emit(this.displayedColumns);
        });
      }
    }
  }

  isColumnVisible(columnId: string): boolean {
    return this.displayedColumns.includes(columnId);
  }

  toggleColumn(columnId: string, event: any) {
    const checked = event.checked;
    if (checked) {
      if (!this.displayedColumns.includes(columnId)) {
        const newCols = [...this.displayedColumns];
        newCols.push(columnId);
        const sortedCols = this.sortColumns(newCols);
        this.displayedColumns = sortedCols;
        this.displayedColumnsChange.emit(this.displayedColumns);
        this.tablePersistenceService.saveColumns(this.tableKey, this.displayedColumns);
      }
    } else {
      if (this.displayedColumns.filter(c => c !== 'check' && c !== 'action' && c !== 'actions' && c !== 'id').length <= 1) {
        if (event && event.source) {
          event.source.checked = true;
        }
        return;
      }
      this.displayedColumns = this.displayedColumns.filter(c => c !== columnId);
      this.displayedColumnsChange.emit(this.displayedColumns);
      this.tablePersistenceService.saveColumns(this.tableKey, this.displayedColumns);
    }
  }

  private sortColumns(cols: string[]): string[] {
    const hasCheck = cols.includes('check');
    const hasId = cols.includes('id');
    const hasAction = cols.includes('action') || cols.includes('actions');
    const actionCol = cols.includes('actions') ? 'actions' : 'action';
    const middleCols = cols.filter(c => c !== 'check' && c !== 'id' && c !== 'action' && c !== 'actions');
    
    middleCols.sort((a, b) => {
      const idxA = this.allColumns.findIndex(c => c.id === a);
      const idxB = this.allColumns.findIndex(c => c.id === b);
      return (idxA === -1 ? 999 : idxA) - (idxB === -1 ? 999 : idxB);
    });

    const sorted: string[] = [];
    if (hasCheck) sorted.push('check');
    if (hasId) sorted.push('id');
    sorted.push(...middleCols);
    if (hasAction) sorted.push(actionCol);
    return sorted;
  }
}
